// outline blue button

import React from "react";

export default function OutlineSmallBtn({ children, onClick, className }) {
  return (
    <button  style={{padding: "6px 16px"}} className={`outline-sub-btn  ${className || ""}`} onClick={onClick}>
      {children}
    </button>
  );
}
